import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

// Services
import productsService from '@services/products';
import psaService from '@services/psa';
import postosService from '@services/postos';

import 'react-confirm-alert/src/react-confirm-alert.css';

// Components
import Menu from '@components/Menu';
import { MdLocalGasStation, MdSettings, MdInvertColors, MdDelete } from "react-icons/md";
import { confirmAlert } from 'react-confirm-alert';
import { NotificationManager } from "react-notifications";
import AutoComplete from '@components/AutoComplete';
import EmpresaSelect from '@components/EmpresaSelect';

import UserContext from "@components/context/userContext";

import "./list.css";

class NozzlesList extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
                loading: true,
            pumps: [],
            products: [],
            machines: [],
            postos: [],
            selectedMachine: null,
            editingNozzle: null,
            showProductSelector: false,
            showNozzleNumberSelector: false,
            selectedPump: null,
            dragOverPump: null,
            dragOverNozzle: null,
        };
        this.loadFunction = this.loadFunction.bind(this);
        this.loadNozzles = this.loadNozzles.bind(this);
        this.loadProducts = this.loadProducts.bind(this);
        this.loadMachines = this.loadMachines.bind(this);
        this.loadPostos = this.loadPostos.bind(this);
        this.handleNozzleClick = this.handleNozzleClick.bind(this);
        this.handleProductSelect = this.handleProductSelect.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleDragStart = this.handleDragStart.bind(this);
        this.handleDragOver = this.handleDragOver.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
        this.handleDragEnd = this.handleDragEnd.bind(this);
        this.handleDropAssociation = this.handleDropAssociation.bind(this);
        this.getProductColor = this.getProductColor.bind(this);
        this.darkenColor = this.darkenColor.bind(this);
        this.handleNozzleNumberSelect = this.handleNozzleNumberSelect.bind(this);
    }

  
    async loadNozzles({ idEmpresa }) {
        try {
            // Usar idEmpresaSec se disponível
            const { idEmpresaSec } = this.context;
            const empresaId = idEmpresaSec || idEmpresa;
            
            const response = await psaService.getNozzles(empresaId);
            
            // Debug: Log the response structure
            console.log('API Response:', response);
            
            // Handle different response structures
            let nozzles = [];
            if (response) {
                if (Array.isArray(response)) {
                    nozzles = response;
                } else if (response.data && Array.isArray(response.data)) {
                    nozzles = response.data;
                } else if (response.nozzles && Array.isArray(response.nozzles)) {
                    nozzles = response.nozzles;
                }
            }
                
            console.log('Processed nozzles:', nozzles);
            console.log('Sample nozzle structure:', nozzles[0]); // Log para ver a estrutura

            // Group nozzles by pump
            const pumpsMap = new Map();
            nozzles.forEach(nozzle => {
                // Verificar se o nozzle tem informações básicas da bomba, mesmo que seja null
                if (!nozzle || typeof nozzle !== 'object') return;
                
                // Verificar se tem informações mínimas da bomba (idpump, pumpname, idmachine)
                if (!nozzle.idpump || !nozzle.pumpname || !nozzle.idmachine) return;
                
                const pumpKey = `${nozzle.idmachine || 'unknown'}-${nozzle.pumpname || 'unknown'}`;
                if (!pumpsMap.has(pumpKey)) {
                    pumpsMap.set(pumpKey, {
                        idmachine: nozzle.idmachine,
                        machine_alias: nozzle.machine_alias || 'Máquina Desconhecida',
                        pumpname: nozzle.pumpname || 'Bomba Desconhecida',
                        idpump: nozzle.idpump,
                        nozzles: []
                    });
                }
                
                // Se o nozzle for null (sem número de nozzle), não adicionar à lista
                // mas a bomba já foi criada no mapa acima
                if (!nozzle.nozzle) return;
                
                // Buscar preço específico do posto se o produto estiver associado
                let postoPrice = null;
                if (nozzle.idproduct) {
                    // Obter o posto da máquina ou usar o posto da nozzle se existir
                    const postoId = nozzle.idposto || this.getPostoForMachine(nozzle.idmachine);
                    console.log('Getting price for nozzle:', nozzle.nozzle, 'machine:', nozzle.idmachine, 'posto:', postoId);
                    
                    // Buscar preço de forma assíncrona
                    this.fetchProductPrice(nozzle.idproduct, postoId).then(priceData => {
                        if (priceData && priceData.price) {
                            // Atualizar o preço na nozzle específica
                            this.setState(prevState => {
                                const newPumps = [...prevState.pumps];
                                const pumpIndex = newPumps.findIndex(p => p.idmachine === nozzle.idmachine && p.pumpname === nozzle.pumpname);
                                if (pumpIndex !== -1) {
                                    const nozzleIndex = newPumps[pumpIndex].nozzles.findIndex(n => n.id === `${nozzle.idpump}-${nozzle.nozzle}`);
                                    if (nozzleIndex !== -1) {
                                        newPumps[pumpIndex].nozzles[nozzleIndex].postoPrice = priceData;
                                    }
                                }
                                return { pumps: newPumps };
                            });
                        }
                    });
                }
                
                pumpsMap.get(pumpKey).nozzles.push({
                    ...nozzle,
                    id: `${nozzle.idpump}-${nozzle.nozzle}`,
                    isAssociated: !!(nozzle.product_name && nozzle.idproduct),
                    productColor: this.getProductColor(nozzle.fuel, nozzle.gas),
                    postoPrice: postoPrice
                });
            });

            const pumps = Array.from(pumpsMap.values());

            this.setState({ 
                pumps,
                loading: false,
                loaded: true 
            });
        } catch (error) {
            console.error('Error loading nozzles:', error);
            NotificationManager.error('Erro ao carregar associações de mangueiras');
            
            this.setState({ 
                loading: false,
                loaded: true 
            });
        }
    }

    async loadProducts({ idEmpresa }) {
        try {
            // Usar idEmpresaSec se disponível
            const { idEmpresaSec } = this.context;
            const empresaId = idEmpresaSec || idEmpresa;
            
            const products = await productsService.getWithFilter(empresaId, { combustivel: true });
            this.setState({ products });
        } catch (error) {
            console.error('Error loading products:', error);
        }
    }

    async loadMachines({ idEmpresa }) {
        try {
            // Usar idEmpresaSec se disponível
            const { idEmpresaSec } = this.context;
            const empresaId = idEmpresaSec || idEmpresa;
            
            const machines = await psaService.listByEmpresa(empresaId);
            this.setState({ machines });
        } catch (error) {
            console.error('Error loading machines:', error);
        }
    }

    async loadPostos({ idEmpresa }) {
        try {
            // Usar idEmpresaSec se disponível
            const { idEmpresaSec } = this.context;
            const empresaId = idEmpresaSec || idEmpresa;
            
            const postos = await postosService.get(empresaId);
            console.log('Loaded postos:', postos);
            this.setState({ postos });
        } catch (error) {
            console.error('Error loading postos:', error);
        }
    }

    getPostoForMachine(machineId) {
        const { machines } = this.state;
        const machine = machines.find(m => m.idmachine === machineId);
        
        if (machine && machine.idposto) {
            return machine.idposto;
        }
        
        // Fallback: assumir posto "0" se não encontrar
        return "0";
    }

    getPostoNameForMachine(machineId) {
        const { machines, postos } = this.state;
        const machine = machines.find(m => m.idmachine === machineId);
        
        if (machine && machine.idposto) {
            // Buscar o nome do posto na lista carregada
            const posto = postos.find(p => p.posto === machine.idposto.toString());
            if (posto && posto.nome) {
                return posto.nome;
            }
            // Fallback: usar formato "Posto X" se não encontrar nome
            return `Posto ${machine.idposto}`;
        }
        
        // Fallback: usar nome da máquina se não encontrar posto
        if (machine && machine.machine_alias) {
            return machine.machine_alias;
        }
        
        return 'Posto Desconhecido';
    }

    async fetchProductPrice(productId, postoId) {
        const { idEmpresaSec, idEmpresa } = this.context;
        const empresaId = idEmpresaSec || idEmpresa;
        
        try {
            console.log('Fetching price for product:', productId, 'at posto:', postoId);
            const prices = await productsService.getPriceById(empresaId, productId);
            
            console.log('Product prices response:', prices);
            
            // Encontrar o posto específico
            const postoData = prices.find((p) => p.idposto === postoId);
            
            if (postoData && postoData.values && postoData.values.length > 0) {
                // Pegar o primeiro preço disponível do array values
                const priceData = postoData.values[0];
                console.log('Price data from values:', priceData);
                return priceData || {};
            }
            
            return {};
        } catch (error) {
            console.error('Erro ao buscar preço do produto:', error);
            return {};
        }
    }

    getProductColor(value) {
        return '#ff6b35';
    }

    darkenColor(color, percent) {
        const num = parseInt(color.replace("#", ""), 16);
        const amt = Math.round(2.55 * percent);
        const R = (num >> 16) - amt;
        const G = ((num >> 8) & 0x00FF) - amt;
        const B = (num & 0x0000FF) - amt;
        return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
            (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
            (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
    }

    handleNozzleClick(nozzle) {
        this.setState({ 
            editingNozzle: nozzle,
            showProductSelector: true 
        });
    }

    handleCreateNozzle(pump) {
        // Mostrar modal para selecionar número da mangueira
        this.setState({ 
            showNozzleNumberSelector: true,
            selectedPump: pump
        });
    }

    handleNozzleNumberSelect(nozzleNumber) {
        const { selectedPump } = this.state;
        
        if (!selectedPump || !nozzleNumber) {
            return;
        }
        
        // Criar um objeto nozzle temporário para permitir associar produto
        const tempNozzle = {
            idpump: selectedPump.idpump,
            nozzle: nozzleNumber.toString(),
            idmachine: selectedPump.idmachine,
            pumpname: selectedPump.pumpname,
            isNew: true
        };
        
        this.setState({ 
            editingNozzle: tempNozzle,
            showProductSelector: true,
            showNozzleNumberSelector: false,
            selectedPump: null
        });
    }

    async handleProductSelect(product) {
        console.log('handleProductSelect called with:', product);
        const { editingNozzle } = this.state;
        console.log('Current editingNozzle state:', editingNozzle);
        
        if (!editingNozzle || !product) {
            console.log('Early return - editingNozzle:', editingNozzle, 'product:', product);
            return;
        }

        console.log('handleProductSelect - Product:', product);
        console.log('handleProductSelect - EditingNozzle:', editingNozzle);

        const profile = this.context;
        console.log('Profile context:', profile);
        
        try {
            // Buscar o preço do produto no posto
            const postoId = editingNozzle.idposto || this.getPostoForMachine(editingNozzle.idmachine);
            const priceData = await this.fetchProductPrice(product.value, postoId);
            console.log('Fetched price data:', priceData);
            
            const requestData = {
                idpump: editingNozzle.idpump,
                nozzle: editingNozzle.nozzle,
                idproduct: product.value,
                idempresa: profile.idEmpresaSec || profile.idEmpresa,
                price: priceData.price || null,
                costprice: priceData.costprice || null
            };
            
            console.log('API Request Data with price:', requestData);
            
            // Update nozzle association
            try {
                const response = await psaService.setNozzle(requestData);
                console.log('API Response:', response);
                if (response.success) {
                    NotificationManager.success('Produto associado com sucesso!');
                    this.loadNozzles(profile);
                    this.setState({ 
                        editingNozzle: null,
                        showProductSelector: false 
                    });
                    console.log('Modal closed after successful association');
                } else {
                    console.error('API Error:', response);
                    NotificationManager.error('Erro ao associar produto: ' + (response.message || 'Erro desconhecido'));
                }
            } catch (error) {
                console.error('Error associating product:', error);
                NotificationManager.error('Erro ao associar produto: ' + (error.response?.data?.message || error.message));
            }
        } catch (error) {
            console.error('Error in handleProductSelect:', error);
            NotificationManager.error('Erro ao processar associação: ' + error.message);
        }
    }

    handleEdit(nozzle) {
        const { history } = this.props;
        // Navigate to edit form with nozzle data
        history.push({
            pathname: `/nozzles/edit`,
            state: { nozzle }
        });
    }

    handleDelete(nozzle) {
        confirmAlert({
            title: 'Confirmar Remoção',
            message: `Tem certeza que deseja remover a associação da mangueira ${nozzle.nozzle} da bomba ${nozzle.pumpname}?`,
            buttons: [
                {
                    label: 'Sim',
                    onClick: () => this.deleteNozzle(nozzle)
                },
                {
                    label: 'Não',
                    onClick: () => {}
                }
            ]
        });
    }

    async deleteNozzle(nozzle) {
        const profile = this.context;
        
        try {
            const response = await psaService.deleteNozzle({
                idpump: nozzle.idpump,
                nozzle: nozzle.nozzle
            });
            
            if (response.success) {
                NotificationManager.success('Associação removida com sucesso');
                this.loadNozzles(profile);
            } else {
                NotificationManager.error('Erro ao remover associação');
            }
        } catch (error) {
            console.error('Error deleting nozzle:', error);
            NotificationManager.error('Erro ao remover associação');
        }
    }

    handleDragStart(e, product) {
        console.log('Drag start - Product:', product);
        e.dataTransfer.setData('application/json', JSON.stringify(product));
        e.dataTransfer.effectAllowed = 'move';
    }

    handleDragOver(e, pumpId, nozzleId) {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        this.setState({ 
            dragOverPump: pumpId,
            dragOverNozzle: nozzleId 
        });
    }

    handleDrop(e, pumpId, nozzleId) {
        e.preventDefault();
        const product = JSON.parse(e.dataTransfer.getData('application/json'));
        
        console.log('Drop event - Product:', product);
        console.log('Drop event - PumpId:', pumpId, 'NozzleId:', nozzleId);
        
        // Find the nozzle and update it
        const { pumps } = this.state;
        const pump = pumps.find(p => p.idpump === pumpId);
        if (pump) {
            const nozzle = pump.nozzles.find(n => n.id === nozzleId);
            if (nozzle) {
                console.log('Found nozzle:', nozzle);
                console.log('Calling handleDropAssociation with:', { value: product.idproduct, label: product.nome });
                this.handleDropAssociation(nozzle, { value: product.idproduct, label: product.nome });
            } else {
                console.log('Nozzle not found for id:', nozzleId);
            }
        }
        
        this.setState({ 
            dragOverPump: null,
            dragOverNozzle: null 
        });
    }

    handleDragEnd() {
        this.setState({ 
            dragOverPump: null,
            dragOverNozzle: null 
        });
    }

    async handleDropAssociation(nozzle, product) {
        console.log('handleDropAssociation called with:', { nozzle, product });
        
        const profile = this.context;
        console.log('Profile context:', profile);
        
        try {
            // Buscar o preço do produto no posto
            const postoId = nozzle.idposto || this.getPostoForMachine(nozzle.idmachine);
            const priceData = await this.fetchProductPrice(product.value, postoId);
            console.log('Fetched price data for drop:', priceData);
            
            const requestData = {
                idpump: nozzle.idpump,
                nozzle: nozzle.nozzle,
                idproduct: product.value,
                idempresa: profile.idEmpresaSec || profile.idEmpresa,
                price: priceData.price || null,
                costprice: priceData.costprice || null
            };
            
            console.log('API Request Data with price (drop):', requestData);
            
            // Update nozzle association
            try {
                const response = await psaService.setNozzle(requestData);
                console.log('API Response:', response);
                if (response.success) {
                    NotificationManager.success('Produto associado com sucesso!');
                    this.loadNozzles(profile);
                } else {
                    console.error('API Error:', response);
                    NotificationManager.error('Erro ao associar produto: ' + (response.message || 'Erro desconhecido'));
                }
            } catch (error) {
                console.error('Error associating product:', error);
                NotificationManager.error('Erro ao associar produto: ' + (error.response?.data?.message || error.message));
            }
        } catch (error) {
            console.error('Error in handleDropAssociation:', error);
            NotificationManager.error('Erro ao processar associação: ' + error.message);
        }
    }

    loadFunction() {
        const profile = this.context;
        if (!this.state.loaded) {
            // Usar idEmpresaSec se disponível (para admins), senão usar idEmpresa
            const empresaId = profile.idEmpresaSec || profile.idEmpresa;
            const profileToUse = { ...profile, idEmpresa: empresaId };
            
            this.loadNozzles(profileToUse);
            this.loadProducts(profileToUse);
            this.loadMachines(profileToUse);
            this.loadPostos(profileToUse);
        }
    }
    
    render() {
        const { 
            pumps, 
            products, 
            editingNozzle, 
            showProductSelector,
            showNozzleNumberSelector,
            selectedPump,
            dragOverPump,
            dragOverNozzle 
        } = this.state;
        const { location, history } = this.props;

        // Group pumps by machine
        const machinesMap = new Map();
        pumps.forEach(pump => {
            const machineKey = pump.idmachine || 'unknown';
            if (!machinesMap.has(machineKey)) {
                machinesMap.set(machineKey, {
                    idmachine: pump.idmachine,
                    machine_alias: pump.machine_alias,
                    pumps: []
                });
            }
            machinesMap.get(machineKey).pumps.push(pump);
        });

        const machines = Array.from(machinesMap.values()).sort((a, b) => {
            // Ordenar por idposto da máquina
            const { machines } = this.state;
            const machineA = machines.find(m => m.idmachine === a.idmachine);
            const machineB = machines.find(m => m.idmachine === b.idmachine);
            
            const postoIdA = machineA?.idposto || "0";
            const postoIdB = machineB?.idposto || "0";
            
            // Converter para número para ordenação numérica
            return parseInt(postoIdA) - parseInt(postoIdB);
        }).map(machine => {
            // Ordenar também as bombas dentro de cada máquina por pumpname
            return {
                ...machine,
                pumps: machine.pumps.sort((a, b) => {
                    // Ordenar bombas por nome (ex: "Bomba 1", "Bomba 2")
                    return a.pumpname.localeCompare(b.pumpname, undefined, { 
                        numeric: true, 
                        sensitivity: 'base' 
                    });
                })
            };
        });

        return (
            <div>
                <Menu loadFunction={this.loadFunction} location={location} history={history} />
                
                {/* Header */}
                <div style={{ 
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    padding: '100px 20px 40px',
                    textAlign: 'center',
                    marginBottom: '30px'
                }}>
                    <h1 style={{ 
                        fontSize: '2.5rem', 
                        margin: '0 0 10px 0',
                        fontWeight: '300'
                    }}>
                        <MdLocalGasStation style={{ marginRight: '15px' }} />
                        Gestão de Mangueiras
                    </h1>
                    <p style={{ fontSize: '1.2rem', opacity: '0.9', margin: 0 }}>
                        Arraste produtos da barra lateral para associar às mangueiras
                    </p>
                </div>

                <EmpresaSelect />

                {/* Floating Products Bar */}
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    right: '20px',
                    transform: 'translateY(-50%)',
                    background: 'white',
                    borderRadius: '15px',
                    boxShadow: '0 15px 40px rgba(0,0,0,0.2)',
                    padding: '20px',
                    zIndex: 1000,
                    maxHeight: '80vh',
                    overflowY: 'auto',
                    minWidth: '250px',
                    border: '2px solid #3498db'
                }}>
                    <h3 style={{ 
                        margin: '0 0 15px 0',
                        color: '#2c3e50',
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: '16px',
                        fontWeight: '600'
                    }}>
                        <MdInvertColors style={{ marginRight: '8px', color: '#3498db' }} />
                        Produtos
                    </h3>
                    <div style={{ 
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        maxHeight: '60vh',
                        overflowY: 'auto'
                    }}>
                        {products.map(product => (
                            <div
                                key={product.idproduct}
                                draggable
                                onDragStart={(e) => this.handleDragStart(e, product)}
                                onDragEnd={this.handleDragEnd}
                                style={{
                                    background: this.getProductColor(product.value),
                                    color: 'white',
                                    padding: '8px 12px',
                                    borderRadius: '20px',
                                    cursor: 'grab',
                                    fontSize: '13px',
                                    fontWeight: '500',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 3px 10px rgba(0,0,0,0.1)',
                                    userSelect: 'none',
                                    textAlign: 'center',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    minHeight: '30px'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateX(-5px)';
                                    e.target.style.boxShadow = '0 5px 15px rgba(0,0,0,0.15)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateX(0)';
                                    e.target.style.boxShadow = '0 3px 10px rgba(0,0,0,0.1)';
                                }}
                                title={product.nome}
                            >
                                {product.nome}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Gas Station Pumps Grid */}
                <div style={{ 
                    display: 'grid',
                    gridTemplateColumns: machines.length === 1 
                        ? 'repeat(auto-fit, minmax(400px, 600px))' 
                        : 'repeat(auto-fit, minmax(400px, 1fr))',
                    gap: '30px',
                    padding: '0 20px 40px 20px',
                    paddingRight: '320px', // Espaço para a barra flutuante
                    perspective: '1000px',
                    justifyContent: machines.length === 1 ? 'center' : 'stretch',
                    maxWidth: machines.length === 1 ? '800px' : 'none',
                    margin: machines.length === 1 ? '0 auto' : '0'
                }}>
                    {machines.map((machine, machineIndex) => (
                        <div key={machine.idmachine} style={{ marginBottom: '40px' }}>
                            {/* Machine Header */}
                            <div style={{
                                background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
                                color: 'white',
                                padding: '20px',
                                borderRadius: '15px 15px 0 0',
                                textAlign: 'center',
                                marginBottom: '0',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
                            }}>
                                <h2 style={{ 
                                    margin: '0 0 10px 0',
                                    fontSize: '1.8rem',
                                    fontWeight: '700',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <MdSettings style={{ marginRight: '10px', color: '#3498db' }} />
                                     {this.getPostoNameForMachine(machine.idmachine)}
                                </h2>
                                <p style={{ margin: 0, opacity: '0.9' }}>
                                    {machine.pumps.length} bomba(s)
                                </p>
                            </div>

                            {/* Pumps for this machine */}
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: machine.pumps.length === 1 
                                    ? 'repeat(auto-fit, minmax(350px, 500px))' 
                                    : 'repeat(auto-fit, minmax(350px, 1fr))',
                                gap: '20px',
                                padding: '20px',
                                background: 'white',
                                borderRadius: '0 0 15px 15px',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                justifyContent: machine.pumps.length === 1 ? 'center' : 'stretch',
                                maxWidth: machine.pumps.length === 1 ? '600px' : 'none',
                                margin: machine.pumps.length === 1 ? '0 auto' : '0'
                            }}>
                                {machine.pumps.map((pump, index) => (
                                    <div
                                        key={pump.idpump}
                                        style={{
                                            background: 'linear-gradient(145deg, #f8f9fa 0%, #e9ecef 100%)',
                                            borderRadius: '15px',
                                            boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
                                            overflow: 'hidden',
                                            border: '2px solid #dee2e6',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-5px)';
                                            e.currentTarget.style.boxShadow = '0 12px 35px rgba(0,0,0,0.15)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
                                        }}
                                    >
                                        {/* Pump Header */}
                                        <div style={{
                                            background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
                                            padding: '15px',
                                            textAlign: 'center',
                                            borderBottom: '2px solid #0056b3'
                                        }}>
                                            <h3 style={{ 
                                                margin: '0 0 5px 0',
                                                fontSize: '1.4rem',
                                                fontWeight: '600',
                                                color: 'white'
                                            }}>
                                                {pump.pumpname}
                                            </h3>
                                            <p style={{ 
                                                margin: 0,
                                                color: 'rgba(255,255,255,0.9)',
                                                fontSize: '0.9rem'
                                            }}>
                                                {pump.nozzles.length} mangueira(s)
                                            </p>
                                        </div>

                                        {/* Nozzles */}
                                        <div style={{
                                            padding: '20px',
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                                    gap: '15px'
                                        }}>
                                            {pump.nozzles.length === 0 ? (
                                                // Área para criar primeira mangueira quando não há nozzles
                                                <div
                                                    onClick={() => this.handleCreateNozzle(pump)}
                                                    style={{
                                                        background: 'linear-gradient(145deg, #28a745 0%, #20c997 100%)',
                                                        color: 'white',
                                                        padding: '40px 20px',
                                                        borderRadius: '12px',
                                                        textAlign: 'center',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.4s ease',
                                                        border: '3px dashed rgba(255,255,255,0.5)',
                                                        boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                                                        position: 'relative',
                                                        overflow: 'hidden'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.transform = 'translateY(-5px) scale(1.02)';
                                                        e.target.style.boxShadow = '0 8px 25px rgba(40, 167, 69, 0.4)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.transform = 'translateY(0) scale(1)';
                                                        e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
                                                    }}
                                                >
                                                    <div style={{
                                                        fontSize: '2.5rem',
                                                        marginBottom: '10px'
                                                    }}>
                                                        +
                                                    </div>
                                                    <div style={{
                                                        fontSize: '1rem',
                                                        fontWeight: '600',
                                                        marginBottom: '5px'
                                                    }}>
                                                        Criar Mangueira
                                                    </div>
                                                    <div style={{
                                                        fontSize: '0.85rem',
                                                        opacity: '0.9'
                                                    }}>
                                                        Clique para adicionar a primeira mangueira
                                                    </div>
                                                </div>
                                            ) : null}
                                            
                                            {/* Mostrar mangueiras existentes */}
                                            {pump.nozzles.map((nozzle, nozzleIndex) => (
                                                <div
                                                    key={nozzle.id}
                                                    draggable={false}
                                                    onDragOver={(e) => this.handleDragOver(e, pump.idpump, nozzle.id)}
                                                    onDrop={(e) => this.handleDrop(e, pump.idpump, nozzle.id)}
                                                    onClick={() => this.handleNozzleClick(nozzle)}
                                                    style={{
                                                        background: nozzle.isAssociated 
                                                            ? `linear-gradient(145deg, ${nozzle.productColor} 0%, ${this.darkenColor(nozzle.productColor, 20)} 100%)`
                                                            : 'linear-gradient(145deg, #6c757d 0%, #495057 100%)',
                                                        color: nozzle.isAssociated ? 'white' : '#f8f9fa',
                                                        padding: '20px 15px',
                                                        borderRadius: '12px',
                                                        textAlign: 'center',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.4s ease',
                                                        border: dragOverPump === pump.idpump && dragOverNozzle === nozzle.id
                                                            ? '3px dashed #ffc107'
                                                            : '2px solid rgba(255,255,255,0.2)',
                                                        transform: dragOverPump === pump.idpump && dragOverNozzle === nozzle.id
                                                            ? 'scale(1.05)'
                                                            : 'scale(1)',
                                                        boxShadow: nozzle.isAssociated
                                                            ? `0 8px 25px rgba(0,0,0,0.3)`
                                                            : '0 4px 15px rgba(0,0,0,0.2)',
                                                        position: 'relative',
                                                        overflow: 'hidden'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (!nozzle.isAssociated) {
                                                            e.target.style.background = 'linear-gradient(145deg, #495057 0%, #343a40 100%)';
                                                            e.target.style.transform = 'translateY(-3px) scale(1.02)';
                                                        } else {
                                                            e.target.style.transform = 'translateY(-3px) scale(1.02)';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (!nozzle.isAssociated) {
                                                            e.target.style.background = 'linear-gradient(145deg, #6c757d 0%, #495057 100%)';
                                                            e.target.style.transform = 'translateY(0) scale(1)';
                                                        } else {
                                                            e.target.style.transform = 'translateY(0) scale(1)';
                                                        }
                                                    }}
                                                >
                                                    {/* Delete Button */}
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            this.handleDelete(nozzle);
                                                        }}
                                                        style={{
                                                            position: 'absolute',
                                                            top: '8px',
                                                            right: '8px',
                                                            background: 'rgba(220, 53, 69, 0.9)',
                                                            border: 'none',
                                                            borderRadius: '50%',
                                                            width: '28px',
                                                            height: '28px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer',
                                                            color: 'white',
                                                            fontSize: '16px',
                                                            transition: 'all 0.3s ease',
                                                            zIndex: 10,
                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.target.style.background = 'rgba(220, 53, 69, 1)';
                                                            e.target.style.transform = 'scale(1.1)';
                                                            e.target.style.boxShadow = '0 4px 12px rgba(220, 53, 69, 0.5)';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.background = 'rgba(220, 53, 69, 0.9)';
                                                            e.target.style.transform = 'scale(1)';
                                                            e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';
                                                        }}
                                                        title="Apagar mangueira"
                                                    >
                                                        <MdDelete />
                                                    </button>

                                                    {/* Nozzle Number */}
                                                    <div style={{
                                                        fontSize: '1.8rem',
                                                        fontWeight: 'bold',
                                                        marginBottom: '8px',
                                                        textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                                                        fontFamily: 'monospace'
                                                    }}>
                                                        {nozzle.nozzle}
                                                    </div>

                                                    {/* Product Name */}
                                                    <div style={{
                                                        fontSize: '0.9rem',
                                                        opacity: '0.9',
                                                        marginBottom: '8px',
                                                        fontWeight: '500',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.5px'
                                                    }}>
                                                        {nozzle.isAssociated 
                                                            ? nozzle.product_name 
                                                            : 'DISPONÍVEL'
                                                        }
                                                    </div>

                                                    {/* Price Display */}
                                                    {nozzle.isAssociated && (
                                                        <div style={{
                                                            fontSize: '1.1rem',
                                                            fontWeight: 'bold',
                                                            background: 'rgba(0,0,0,0.2)',
                                                            padding: '5px 10px',
                                                            borderRadius: '10px',
                                                            marginTop: '5px',
                                                            fontFamily: 'monospace',
                                                            textShadow: '0 1px 2px rgba(0,0,0,0.5)'
                                                        }}>
                                                             €{(() => {
                                                                 // Prioridade: postoPrice -> nozzle.price -> fallback para 0
                                                                 if (nozzle.postoPrice && nozzle.postoPrice.price) {
                                                                     return parseFloat(nozzle.postoPrice.price).toFixed(3);
                                                                 }
                                                                 if (nozzle.price) {
                                                                     return parseFloat(nozzle.price).toFixed(3);
                                                                 }
                                                                 return '0.00';
                                                             })()}
                                                        </div>
                                                    )}

                                                    {/* Last Counter Value */}
                                                    {nozzle.last_counter_value && (
                                                        <div style={{
                                                            fontSize: '0.75rem',
                                                            marginTop: '8px',
                                                            background: 'rgba(255,255,255,0.2)',
                                                            padding: '4px 8px',
                                                            borderRadius: '6px',
                                                            fontFamily: 'monospace',
                                                            textShadow: '0 1px 2px rgba(0,0,0,0.3)'
                                                        }}>
                                                            Contador: {nozzle.last_counter_value}
                                                        </div>
                                                    )}

                                                    {/* Status Indicator */}
                                                    <div style={{
                                                        position: 'absolute',
                                                        bottom: '5px',
                                                        left: '50%',
                                                        transform: 'translateX(-50%)',
                                                        width: '30px',
                                                        height: '4px',
                                                        background: nozzle.isAssociated ? '#28a745' : '#dc3545',
                                                        borderRadius: '2px',
                                                        boxShadow: nozzle.isAssociated 
                                                            ? '0 0 10px #28a745' 
                                                            : '0 0 5px #dc3545'
                                                    }}></div>
                                                </div>
                                                ))
                                            }
                                            
                                            {/* Botão para adicionar mais mangueiras */}
                                            {pump.nozzles.length !== 0 && <div
                                                onClick={() => this.handleCreateNozzle(pump)}
                                                style={{
                                                    background: 'linear-gradient(145deg, #28a745 0%, #20c997 100%)',
                                                    color: 'white',
                                                    padding: '20px 15px',
                                                    borderRadius: '12px',
                                                    textAlign: 'center',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.4s ease',
                                                    border: '2px dashed rgba(255,255,255,0.5)',
                                                    boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    minHeight: '120px'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = 'translateY(-3px) scale(1.02)';
                                                    e.target.style.boxShadow = '0 8px 25px rgba(40, 167, 69, 0.4)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = 'translateY(0) scale(1)';
                                                    e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
                                                }}
                                            >
                                                <div style={{
                                                    fontSize: '2rem',
                                                    marginBottom: '8px',
                                                    fontWeight: 'bold'
                                                }}>
                                                    +
                                                </div>
                                                <div style={{
                                                    fontSize: '0.9rem',
                                                    fontWeight: '600',
                                                    opacity: '0.95'
                                                }}>
                                                    Adicionar Mangueira
                                                </div>
                                            </div>}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Nozzle Number Selector Modal */}
                {showNozzleNumberSelector && selectedPump && (() => {
                    // Obter números já usados nesta bomba
                    const usedNumbers = (selectedPump.nozzles || []).map(n => n.nozzle.toString());
                    // Criar array de 1 a 9 e filtrar os disponíveis
                    const availableNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9].filter(num => !usedNumbers.includes(num.toString()));
                    
                    return (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'rgba(0,0,0,0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 1001
                        }}>
                            <div style={{
                                background: 'white',
                                borderRadius: '20px',
                                padding: '30px',
                                maxWidth: '400px',
                                width: '90%',
                                boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
                            }}>
                                <h3 style={{ 
                                    margin: '0 0 20px 0',
                                    color: '#2c3e50',
                                    textAlign: 'center'
                                }}>
                                    Selecionar Número da Mangueira
                                </h3>
                                <p style={{
                                    margin: '0 0 20px 0',
                                    color: '#6c757d',
                                    textAlign: 'center',
                                    fontSize: '0.9rem'
                                }}>
                                    {selectedPump.pumpname}
                                </p>
                                
                                {availableNumbers.length === 0 ? (
                                    <div style={{
                                        textAlign: 'center',
                                        padding: '20px',
                                        color: '#dc3545'
                                    }}>
                                        <p>Todas as mangueiras (1-9) já estão em uso nesta bomba.</p>
                                    </div>
                                ) : (
                                    <div style={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(3, 1fr)',
                                        gap: '12px',
                                        marginBottom: '20px'
                                    }}>
                                        {availableNumbers.map(num => (
                                            <button
                                                key={num}
                                                onClick={() => this.handleNozzleNumberSelect(num)}
                                                style={{
                                                    background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
                                                    color: 'white',
                                                    border: 'none',
                                                    padding: '20px',
                                                    borderRadius: '12px',
                                                    cursor: 'pointer',
                                                    fontSize: '1.5rem',
                                                    fontWeight: 'bold',
                                                    transition: 'all 0.3s ease',
                                                    boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = 'translateY(-3px) scale(1.05)';
                                                    e.target.style.boxShadow = '0 8px 25px rgba(0, 123, 255, 0.4)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = 'translateY(0) scale(1)';
                                                    e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
                                                }}
                                            >
                                                {num}
                                            </button>
                                        ))}
                                    </div>
                                )}
                                
                                <button
                                    onClick={() => {
                                        this.setState({ 
                                            showNozzleNumberSelector: false,
                                            selectedPump: null
                                        });
                                    }}
                                    style={{
                                        background: '#6c757d',
                                        color: 'white',
                                        border: 'none',
                                        padding: '12px 24px',
                                        borderRadius: '10px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        width: '100%'
                                    }}
                                >
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    );
                })()}

                {/* Product Selector Modal */}
                {showProductSelector && editingNozzle && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000
                    }}>
                        <div style={{
                            background: 'white',
                            borderRadius: '20px',
                            padding: '30px',
                            maxWidth: '500px',
                            width: '90%',
                            boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
                        }}>
                            <h3 style={{ 
                                margin: '0 0 20px 0',
                                color: '#2c3e50',
                                textAlign: 'center'
                            }}>
                                Associar Produto à Mangueira {editingNozzle.nozzle}
                            </h3>
                            <AutoComplete
                                name="product"
                                options={products.map(p => ({
                                    value: p.idproduct,
                                    label: p.nome
                                }))}
                                handleChange={(e) => {
                                    console.log('AutoComplete handleChange event:', e);
                                    console.log('e.target.value:', e.target.value);
                                    
                                    // e.target.value is the selected option object from react-select
                                    if (e.target.value && e.target.value.value) {
                                        this.handleProductSelect(e.target.value);
                                    }
                                }}
                                placeholder="Selecione um produto..."
                                style={{ marginBottom: '20px' }}
                            />
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                gap: '10px'
                            }}>
                                <button
                                    onClick={() => {
                                        console.log('Cancel button clicked');
                                        this.setState({ 
                                            editingNozzle: null, 
                                            showProductSelector: false 
                                        });
                                    }}
                                    style={{
                                        background: '#6c757d',
                                        color: 'white',
                                        border: 'none',
                                        padding: '12px 24px',
                                        borderRadius: '10px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        flex: 1
                                    }}
                                >
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* CSS Animation */}
                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
        );
    }
}

export default withRouter(NozzlesList);
